'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _immutableHelper = require('../../../../../common/utils/immutableHelper');

var _getErrorEmailHref = require('../utils/getErrorEmailHref');

var _getErrorEmailHref2 = _interopRequireDefault(_getErrorEmailHref);

var _rollbarService = require('../../../../analytics/rollbarService');

var _navigationActions = require('../../../../reducers/navigationActions');

var _FullScreenErrorModal = require('../../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

var _notificationConstants = require('../../../../../common/notifications/notificationConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Util


// Actions


// Components


// Constants


var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.getIn(['app', 'currentUser']),
        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        backToLogin: function backToLogin(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToLogin)());
        }
    };
};

/**
 * This component is intended to be used when an unknown / unhandled error occurs.
 * For example we already handle the board timeout issue, but if we didn't then this modal would be defaulted to.
 */

var UnknownErrorModal = function (_React$Component) {
    _inherits(UnknownErrorModal, _React$Component);

    function UnknownErrorModal() {
        _classCallCheck(this, UnknownErrorModal);

        return _possibleConstructorReturn(this, (UnknownErrorModal.__proto__ || Object.getPrototypeOf(UnknownErrorModal)).apply(this, arguments));
    }

    _createClass(UnknownErrorModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            (0, _rollbarService.manuallyReportError)({
                error: this.props.error,
                sensitive: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                error = _props.error,
                isGuest = _props.isGuest,
                boardId = _props.boardId,
                backToLogin = _props.backToLogin,
                currentUser = _props.currentUser,
                close = _props.close;

            var code = (0, _immutableHelper.prop)('code', error) || 'UNKNOWN_ERROR';
            var id = (0, _immutableHelper.prop)('id', error);

            var idComponent = id ? _react2.default.createElement(
                'p',
                { className: 'info' },
                'Error ID: ',
                _react2.default.createElement(
                    'strong',
                    null,
                    id
                )
            ) : null;

            var guestActions = [{ text: 'Log in', func: backToLogin }];
            var loggedInActions = [];
            var actions = isGuest ? guestActions : loggedInActions;

            var emailConfig = {
                error: error,
                boardId: boardId,
                currentUser: currentUser,
                subject: 'Milanote issue',
                introduction: 'I encountered an issue while using Milanote.'
            };

            return _react2.default.createElement(
                _FullScreenErrorModal2.default,
                { close: close },
                _react2.default.createElement(
                    'h2',
                    null,
                    'Something went wrong'
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        'We apologise for the inconvenience, the error has been logged and we\'ll try to resolve it soon.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please try again later.'
                    ),
                    _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Contact',
                        ' ',
                        _react2.default.createElement(
                            'a',
                            { href: (0, _getErrorEmailHref2.default)(emailConfig) },
                            _notificationConstants.MILANOTE_EMAILS.SUPPORT
                        ),
                        ' ',
                        'for more help.'
                    ),
                    idComponent,
                    _react2.default.createElement(
                        'p',
                        { className: 'info' },
                        'Error code: ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            code
                        )
                    )
                )
            );
        }
    }]);

    return UnknownErrorModal;
}(_react2.default.Component);

UnknownErrorModal.propTypes = {
    error: _propTypes2.default.object,
    currentUser: _propTypes2.default.object,
    isGuest: _propTypes2.default.bool,
    backToLogin: _propTypes2.default.func,
    close: _propTypes2.default.func,
    boardId: _propTypes2.default.string
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

exports.default = enhance(UnknownErrorModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/components/UnknownErrorModal.js
// module id = 1767
// module chunks = 0